import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { Input, Col } from "components/bootstrap";
import * as FormsUtils from "util/FormsUtils";
const NumberExpression = ({ expression, onChange, renderLabel, validation = {} }) => {
  const handleChange = (event) => {
    const nextExpression = cloneDeep(expression);
    nextExpression.value = event.target.value === "" ? "" : FormsUtils.getValueFromInput(event.target);
    onChange({ conditions: nextExpression });
  };
  return /* @__PURE__ */ React.createElement(Col, { md: 3 }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "aggregation-threshold",
      name: "threshold",
      label: renderLabel ? "Threshold" : "",
      type: "number",
      value: expression == null ? void 0 : expression.value,
      bsStyle: validation.message ? "error" : null,
      help: validation.message,
      onChange: handleChange
    }
  ));
};
export default NumberExpression;
